export enum FeatureEnum {
    TradingPlans = 'crm.tradingPlans',
    CloseoutPlans = 'alaric-crm.closeout-plans',
    BatchAccountCreation = 'crm.batch-account-creation',
}